<script>
import TempalteSelector from './TempalteSelector.vue'
import nodeID from '@/mixins/nodeID'
import { getMetadataYamlByCategory } from '@/api/metadata'

export default {
  name: 'ConnectionSelector',

  extends: TempalteSelector,

  props: {
    type: { type: String, default: 'edgex' }, //  edgex| mqtt。Only `edgex` and `mqtt` support connectionSelector
    lists: { type: Array, default: () => null },
  },

  mixins: [nodeID],

  computed: {
    // Only `edgex` and `mqtt` support connectionSelector
    isCanConnection() {
      return (val) => {
        if (val) {
          return ['mqtt', 'edgex'].includes(val)
        }
        return ['mqtt', 'edgex'].includes(this.type)
      }
    },
  },

  watch: {
    type: {
      immediate: true,
      handler(newVal) {
        if (this.lists) {
          this.list = this.lists
        } else if (newVal) {
          if (this.isCanConnection(newVal)) {
            this.init()
            return
          }
          this.myValue = ''
          this.list = []
        }
      },
    },
  },

  created() {
    if (this.lists) {
      this.list = this.lists
    }
  },

  methods: {
    // get connections
    getList() {
      return new Promise((resolve, reject) => {
        const data = {
          nodeID: this.nodeID,
          name: this.type,
        }
        if (this.type && this.isCanConnection(this.type)) {
          getMetadataYamlByCategory('connections', data)
            .then((res) => {
              const { data: connectionData } = res
              const connections = Object.keys(connectionData)
              resolve(connections)
            })
            .catch((error) => {
              reject(error)
            })
        } else {
          resolve([])
        }
      })
    },
  },
}
</script>
